import { useLocation } from 'react-router-dom';
import { CHECKOUT_ROUTES } from 'typescript/constants/enums/checkout';

const SHOW_SHIPPING_LOADING_PATHS = new Set([CHECKOUT_ROUTES.DELIVERY]);
const SHOW_TAX_LOADING_PATHS = new Set([CHECKOUT_ROUTES.DELIVERY]);
const SHOW_INSTALLMENTS_LOADING_PATHS = new Set([CHECKOUT_ROUTES.PAYMENT]);

const useShowLoading = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const showShippingLoading = SHOW_SHIPPING_LOADING_PATHS.has(pathname);
  const showTaxLoading = SHOW_TAX_LOADING_PATHS.has(pathname);
  const showInstallmentsLoading = SHOW_INSTALLMENTS_LOADING_PATHS.has(pathname);

  return {
    showShippingLoading,
    showTaxLoading,
    showInstallmentsLoading,
  };
};

export default useShowLoading;
